import React from 'react';
export const Returns = () => {
  return <div className="py-20 lg:py-24 bg-white min-h-[calc(100vh-300px)]" data-id="element-1067">
      <div className="max-w-content mx-auto px-5 sm:px-8 lg:px-12" data-id="element-1068">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-1069">
          <h1 className="text-4xl md:text-5xl font-heading font-bold text-ink mb-6 leading-tight" data-id="element-1070">
            Returns Policy
          </h1>
          <p className="text-lg text-gray-600" data-id="element-1071">
            Information regarding returns, exchanges, and defective items.
          </p>
        </div>

        <div className="max-w-3xl mx-auto prose prose-lg prose-red text-gray-600" data-id="element-1072">
          <h3 data-id="element-1073">Custom Apparel</h3>
          <p data-id="element-1074">
            Because all custom uniforms and apparel are made-to-order
            specifically for your organization,{' '}
            <strong data-id="element-1075">
              we do not accept returns or exchanges for custom items
            </strong>{' '}
            unless there is a manufacturing defect or an error on our part.
          </p>
          <p data-id="element-1076">
            We strongly encourage ordering sizing samples before placing your
            final order to ensure proper fit, as items cannot be returned due to
            sizing issues.
          </p>

          <h3 data-id="element-1077">Manufacturing Defects</h3>
          <p data-id="element-1078">
            If you receive an item with a manufacturing defect or an error that
            deviates from the approved digital mockup, please contact our
            support team within 14 days of receiving your order. We will review
            the issue and, if verified, provide a replacement at no additional
            cost.
          </p>

          <h3 data-id="element-1079">Blank Samples</h3>
          <p data-id="element-1080">
            Blank sizing samples may be returned for a refund of the sample
            deposit, provided they are returned in unworn, unwashed, and
            original condition within 30 days of receipt. The customer is
            responsible for return shipping costs for samples.
          </p>

          <h3 data-id="element-1081">Reporting an Issue</h3>
          <p data-id="element-1082">
            To report a defect or issue with your order, please email our
            support team with your order number, a description of the problem,
            and clear photos demonstrating the issue.
          </p>
        </div>
      </div>
    </div>;
};